var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTripleS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 612.73291 572",
    width: 612.73291,
    height: 572,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 27.975196,572 H 175.6852 c 55.22,-72.32 55.66,-138.07 7.45,-216.52 -52.16,-86.79 -47.78,-169.63 20.16,-247.65 H 55.585196 c -67.93,77.17 -72.32,159.11 -20.16,247.65 46.46,78.45 46.46,144.2 -7.45,216.52 z",
    id: "path6",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 27.975196,572 H 175.6852 c 55.22,-72.32 55.66,-138.07 7.45,-216.52 -52.16,-86.79 -47.78,-169.63 20.16,-247.65 H 55.585196 c -67.93,77.17 -72.32,159.11 -20.16,247.65 46.46,78.45 46.46,144.2 -7.45,216.52 z",
    id: "path8",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 225.2152,572 h 147.71 c 55.22,-72.32 55.66,-138.07 7.45,-216.52 -52.16,-86.79 -47.78,-169.63 20.16,-247.65 h -147.71 c -67.94,77.17 -72.32,159.11 -20.16,247.65 46.46,78.45 46.46,144.2 -7.45,216.52 z",
    id: "path10",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 422.4552,572 h 147.71 c 55.22,-72.32 55.66,-138.07 7.45,-216.52 -52.16,-86.79 -47.78,-169.63 20.16,-247.65 h -147.7 c -67.95,77.17 -72.33,159.11 -20.17,247.65 46.46,78.45 46.46,144.2 -7.45,216.52 z",
    id: "path12",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 28.585196,20.28 h 27.36 V 89 h 27.61 V 20.28 H 110.6352 V 1.57 H 28.585196 Z M 118.7452,1.57 V 89 h 26.33 V 20 h 13.61 c 6.67,0 12.29,1.18 12.29,9.42 0,4.85 -3.66,11.26 -15.83,11.52 -2.09,-0.26 -4.44,-0.53 -6.67,-0.79 7.2,16.35 13.22,32.71 19.1,48.8 h 29.7 c -6.67,-12.82 -12.82,-25.51 -19,-38.59 12.3,-4.32 19,-12.3 19,-22.24 0,-18.32 -10.47,-26.56 -31.92,-26.56 z m 92,87.39 h 27.33 V 1.57 h -27.36 V 89 Z m 45.79,-87.39 V 89 h 26.3 V 20 h 9.55 c 5.36,0 11,0.53 11,9.42 0,5.89 -4.32,9.69 -12.82,9.69 -1.83,0 -3,-0.53 -5.36,-0.79 l 5.1,17.14 c 3.14,0.26 5.89,0.52 8.76,0.78 20.67,-0.26 30.35,-13.73 30.35,-28.38 0,-19.63 -14.25,-26.3 -24.07,-26.3 z m 83.54,87.43 h 67.8 V 70.25 h -40.42 V 1.57 h -27.38 z m 104.3,-53.42 v -15.3 h 43.7 V 1.57 h -71 V 89 h 71 V 70.25 h -43.7 V 54.42 h 36.64 V 35.58 Z m 52,28.65 h 34.92 V 46.57 h -34.97 v 17.66 z m 101.39,-40.94 -3.15,-20.67 A 130.91,130.91 0 0 0 571.4152,0 c -27.6,0 -31.92,15.83 -31.92,22.76 0,22.24 33.1,31.14 33.1,42.13 0,5 -4.84,6.67 -11.38,6.93 a 61.19,61.19 0 0 1 -23.56,-5.89 l 3,21.46 c 14.13,2.64 16.88,2.9 25.91,3.16 16.75,0.53 33.62,-6.69 33.62,-23.83 0,-23 -33.36,-28.91 -33.36,-41.6 0,-3.93 4.84,-6.15 11.64,-6.15 a 52,52 0 0 1 19.24,4.32 z",
    id: "path14",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTripleS);
export default __webpack_public_path__ + "static/media/triple-s.f5ef5ee66a46b7962f9c2c344a4f92a1.svg";
export { ForwardRef as ReactComponent };